(() => {
  if (window.SKULL_PROMO_CLOCK) return;
  const fixedDeadline = Date.parse(window.SKULL_PROMO_CLOCK_CONFIG?.endsAt || window.SKULL_OFFER?.endsAt);
  const subscribers = new Set();
  let timer = 0;
  let notifiedExpired = false;
  const now = () => Date.now();
  function snapshot() {
    const deadline = window.SKULL_OFFER?.dailyReset ? Date.parse(window.SKULL_OFFER.endsAt) : fixedDeadline;
    const remainingMs = Number.isFinite(deadline) ? Math.max(0, deadline - now()) : 0;
    return { remainingMs, deadline, expired: remainingMs === 0 };
  }
  function format(remainingMs) {
    const seconds = Math.max(0, Math.ceil(remainingMs / 1000));
    const days = Math.floor(seconds / 86400);
    const time = [Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60]
      .map(value => String(value).padStart(2, '0')).join(':');
    return days ? `${days}d ${time}` : time;
  }
  function publish() {
    const state = snapshot();
    document.documentElement.toggleAttribute('data-skull-promo-expired', state.expired);
    if (state.expired && !notifiedExpired) {
      notifiedExpired = true;
      document.dispatchEvent(new CustomEvent('skull:promo-expired'));
    }
    for (const subscriber of subscribers) {
      try { subscriber(state); } catch (error) { console.error('SKULL countdown view:', error); }
    }
  }
  function schedule() {
    clearTimeout(timer);
    timer = 0;
    if (document.hidden || !subscribers.size || snapshot().expired) return;
    timer = setTimeout(() => { publish(); schedule(); }, 1000 - (now() % 1000) + 15);
  }
  window.SKULL_PROMO_CLOCK = {
    snapshot, format,
    subscribe(callback) {
      if (typeof callback !== 'function') return () => {};
      subscribers.add(callback);
      callback(snapshot());
      schedule();
      return () => { subscribers.delete(callback); schedule(); };
    }
  };
  document.addEventListener('visibilitychange', () => { if (!document.hidden) publish(); schedule(); });
  window.addEventListener('pagehide', () => { clearTimeout(timer); timer = 0; });
  window.addEventListener('pageshow', () => { publish(); schedule(); });
  publish();
  document.dispatchEvent(new CustomEvent('skull:promo-clock-ready'));
})();
